// gatsby-browser.js
export const onInitialClientRender = () => {
  if (typeof window !== 'undefined') {
    const element = document.querySelector('.global-element');
    if (element) {
      element.style.color = 'blue';
    }
  }
};
